import { BsRobot } from "react-icons/bs";
import { BsStars } from "react-icons/bs";
import { FaUnlockAlt } from "react-icons/fa";
import { TbMoodSmile } from "react-icons/tb";
import { BiTargetLock } from "react-icons/bi";
import { IoScanOutline } from "react-icons/io5";
import { FiSend, FiMusic } from "react-icons/fi";
import { RiGraduationCapLine } from "react-icons/ri";
import { HiOutlineLightningBolt } from "react-icons/hi";
import { FaCloud, FaGlobe, FaMobileRetro } from "react-icons/fa6";
import { MdSecurity, MdOutlineAnalytics, MdOutlineLightbulb, MdOutlineShoppingBag } from "react-icons/md";
import { FaAws, FaMicrosoft, FaGoogle, FaApple, FaPlane, FaWifi } from "react-icons/fa";
import {
  MdOutlinePhoneIphone,
  MdOutlineWeb,
  MdOutlinePsychology,
  MdOutlineCloud,
  MdOutlineSecurity,
  MdOutlineTv,
  MdOutlineCampaign,
  MdOutlineCurrencyBitcoin,
  MdOutlineDesignServices,
  MdOutlineBugReport,
} from "react-icons/md";

export const GLOBE_CARDS = [
  {
    id: 0,
    icon: <FaCloud />,
    label: "Cloud & DevOps",
    color: "#3b5bdb",
    region: "Global",
    kpi1: ["Uptime", "99.9%"],
    kpi2: ["Deploy Speed", "2× faster"],
    tags: ["AWS", "Kubernetes", "Terraform"],
    trend: [60, 65, 70, 74, 78, 82],
  },
  {
    id: 1,
    icon: <BsRobot />,
    label: "AI / ML Solutions",
    color: "#0a9dca",
    region: "Enterprise",
    kpi1: ["Accuracy", "96.4%"],
    kpi2: ["Processing", "10× faster"],
    tags: ["TensorFlow", "PyTorch", "LLMs"],
    trend: [40, 48, 58, 68, 78, 86],
  },
  {
    id: 2,
    icon: <FaMobileRetro />,
    label: "Mobile Development",
    color: "#74c614",
    region: "Cross-Platform",
    kpi1: ["Avg Rating", "4.8★"],
    kpi2: ["Downloads", "2M+"],
    tags: ["React Native", "Flutter", "Swift"],
    trend: [55, 58, 62, 67, 73, 78],
  },
  {
    id: 3,
    icon: <FaUnlockAlt />,
    label: "Cybersecurity",
    color: "#e07b00",
    region: "Zero Trust",
    kpi1: ["Incidents", "↓ 94%"],
    kpi2: ["Response", "<2 min"],
    tags: ["Okta", "CrowdStrike", "SIEM"],
    trend: [72, 74, 75, 77, 79, 82],
  },
  {
    id: 4,
    icon: <FaGlobe />,
    label: "Web Development",
    color: "#9c36c4",
    region: "Full Stack",
    kpi1: ["Performance", "98/100"],
    kpi2: ["Load Time", "0.8s"],
    tags: ["Next.js", "Node.js", "PostgreSQL"],
    trend: [50, 56, 62, 69, 75, 80],
  },
];

export const ourServices = [
  {
    icon: <MdOutlinePhoneIphone size={32} />,
    title: "Mobile App Development",
    description: "Custom iOS and Android mobile applications designed for seamless performance, intuitive user experiences, and scalable business growth across all devices.",
    accent: "#3B5BDB",
    link: "mobile-app-development-services-india",
  },
  {
    icon: <MdOutlineWeb size={32} />,
    title: "Web Development",
    description: "Scalable and high-performance web development solutions built with modern technologies to deliver fast, secure, and user-friendly digital experiences.",
    accent: "#0ea5e9",
    link: "web-app-development-services-india",
  },
  {
    icon: <MdOutlinePsychology size={32} />,
    title: "AI & Machine Learning",
    description: "Advanced AI and machine learning solutions that automate workflows, improve decision-making, and help businesses achieve smarter digital transformation.",
    accent: "#16a34a",
    link: "ai-ml-development-services-india",
  },
  {
    icon: <MdOutlineCloud size={32} />,
    title: " DevOps & Cloud",
    description: "Reliable DevOps and cloud services that enhance infrastructure scalability, deployment speed, system security, and overall operational efficiency.",
    accent: "#0891b2",
    link: "devops-cloud-development-services-india",
  },
  {
    icon: <MdOutlineShoppingBag size={32} />,
    title: "E-Commerce Solutions",
    description:
      "End-to-end e-commerce development services, including custom storefronts, multi-vendor marketplaces, payment gateways, inventory management, and high-performance shopping experiences.",
    accent: "#0ea5e9",
    link: "ecommerce-cms-services-india",
  },
  {
    icon: <MdOutlineTv size={32} />,
    title: "TV App Development",
    description: "Professional TV app development services for Roku, Apple TV, Android TV, and Fire TV with smooth streaming and optimized user experiences.",
    accent: "#9333ea",
    link: "ott-platform-development-services-india",
  },
  {
    icon: <MdOutlineCampaign size={32} />,
    title: "Digital Marketing",
    description: "Data-driven digital marketing strategies that improve online visibility, generate qualified leads, and increase customer engagement and conversions.",
    accent: "#f59e0b",
    link: "digital-marketing-services-india",
  },
  {
    icon: <MdOutlineCurrencyBitcoin size={32} />,
    title: "Blockchain Development",
    description: "Secure blockchain development services for smart contracts, decentralized applications, and scalable Web3 solutions tailored for modern businesses.",
    accent: "#0ea5e9",
    link: "blockchain-development-services-india",
  },
  {
    icon: <MdOutlineDesignServices size={32} />,
    title: "UI/UX & Design Services",
    description: "Creative UI/UX design services focused on building visually engaging, user-friendly, and conversion-focused digital experiences across platforms.",
    accent: "#ec4899",
    link: "ui-ux-design-services-india",
  },
  {
    icon: <MdOutlineBugReport size={32} />,
    title: "Testing & Maintenance",
    description: "Comprehensive testing and maintenance services that ensure application stability, performance optimization, security, and long-term business reliability.",
    accent: "#ef4444",
    link: "testing-and-maintenance-services-india",
  },
];

export const STORIES = [
  {
    id: "nexgen",
    name: "NexGen IOT",
    image: "/images/successImages/next-gen-banner.webp",
    tag: "NexGen IOT Solutions...",
    accentColor: "var(--c-warn)",
    logoSrc: "/images/nexgen-logo.png",
    gridClass: "story--hero",
  },
  {
    id: "recon3d",
    name: "RECON-3D",
    image: "/images/successImages/recon.webp",
    tag: "LegalTech",
    accentColor: "var(--c-accent)",
    logoText: "RECON-3D",
    gridClass: "story--tall",
  },
  {
    id: "iitiimshaadi",
    name: "IITIIMShaadi",
    image: "/images/successImages/iitiimshadi.webp",
    tag: "Matrimony",
    accentColor: "#9f1239",
    logoText: "IITIIMShaadi",
    gridClass: "story--medium",
  },

  {
    id: "aha",
    name: "aha",
    image: "/images/successImages/aha.webp",
    tag: "OTT · TV App",
    accentColor: "#be185d",
    logoText: "aha",
    gridClass: "story--wide",
  },
  {
    id: "easemytrip",
    name: "EaseMyTrip",
    image: "/images/successImages/easemyTrip.webp",
    tag: "Travel · Mobile App",
    accentColor: "var(--c-brand)",
    logoText: "EaseMyTrip",
    gridClass: "story--tall-bottom",
  },
  {
    id: "100mb",
    name: "100 MB",
    image: "/images/successImages/100MB-1.5.webp",
    tag: "Sports",
    accentColor: "var(--c-lime)",
    logoText: "100 MB",
    gridClass: "story--small",
  },
];

export const partners = [
  {
    name: "Google",
    image: "/images/logo/google_logo.png",
    DarkImage: "/images/logo/google_logo.png",
  },
  {
    name: "Microsoft",
    image: "/images/logo/microsoft_logo.png",
    DarkImage: "/images/logo/microsoft_logo.png",
  },
  {
    name: "Amazon",
    image: "/images/logo/amazonW.png",
    DarkImage: "/images/logo/amazon_logo.png",
  },
  {
    name: "Adobe",
    image: "/images/logo/adobeW.png",
    DarkImage: "/images/logo/Adobe_Corporate_logo.png",
  },
  {
    name: "IBM",
    image: "/images/logo/IBM_logo.svg",
    DarkImage: "/images/logo/IBM_logo.png",
  },
  {
    name: "Oracle",
    image: "/images/logo/oracleW.png",
    DarkImage: "/images/logo/Oracle_logo.png",
  },
];

export const clients = [
  {
    name: "Aha",
    image: "/images/partners/clients/aha.webp",
    darkImage: "/images/partners/clients/aha.webp",
  },

  {
    name: "imWow",
    image: "/images/partners/clients/imwowW.png",
    darkImage: "/images/partners/clients/imwow.webp",
  },
  {
    name: "easeMY",
    image: "/images/partners/clients/EsaeW.png",
    darkImage: "/images/partners/clients/ease_my_trip.webp",
  },
  {
    name: "star",
    image: "/images/partners/clients/st.png",
    darkImage: "/images/partners/clients/star_sports.webp",
  },
  {
    name: "100mb",
    image: "/images/partners/clients/100w.png",
    darkImage: "/images/partners/clients/100mb.webp",
  },
  {
    name: "nextgen",
    image: "/images/partners/clients/nexgen.webp",
    darkImage: "/images/partners/clients/nexgen.webp",
  },
  {
    name: "recon",
    image: "/images/partners/clients/recon.webp",
    darkImage: "/images/partners/clients/recon.webp",
  },
  {
    name: "mm",
    image: "/images/partners/clients/mm.webp",
    darkImage: "/images/partners/clients/mm.webp",
  },
  {
    name: "afp",
    image: "/images/partners/clients/afp.webp",
    darkImage: "/images/partners/clients/afp.webp",
  },
  {
    name: "bank",
    image: "/images/partners/clients/bank.webp",
    darkImage: "/images/partners/clients/bank.webp",
  },
  {
    name: "Theriome",
    image: "/images/partners/clients/theriome.webp",
    darkImage: "/images/partners/clients/theriome-logo-wht.webp",
  },
  {
    name: "mTv",
    image: "/images/partners/clients/motvW.png",
    darkImage: "/images/partners/clients/motv.png",
  },
  {
    name: "iim",
    image: "/images/partners/clients/iim.webp",
    darkImage: "/images/partners/clients/iim.webp",
  },
  {
    name: "rightLife",
    image: "/images/partners/clients/rightW.png",
    darkImage: "/images/partners/clients/rl.webp",
  },
  {
    name: "recon",
    image: "/images/partners/clients/hhh.webp",
    darkImage: "/images/partners/clients/hhh.webp",
  },
];
export const mobileServices = [
  {
    name: "dotnet",
    image: "/images/partners/tech/mobile/dotnet.webp",
  },

  {
    name: "electron",
    image: "/images/partners/tech/mobile/electron.webp",
  },
  {
    name: "firebase",
    image: "/images/partners/tech/mobile/firebase.webp",
  },
  {
    name: "fluter",
    image: "/images/partners/tech/mobile/fluter.webp",
  },
  {
    name: "ionic",
    image: "/images/partners/tech/mobile/ionic.webp",
  },
  {
    name: "kotlin",
    image: "/images/partners/tech/mobile/kotlin.webp",
  },
  {
    name: "reactNative",
    image: "/images/partners/tech/mobile/react_native.webp",
  },
  {
    name: "recon",
    image: "/images/partners/tech/mobile/swift.webp",
  },
];

export const testimonials = [
  {
    name: "Akshay Gupta",
    role: "Assistant Vice President",
    company: "Gemini Solutions",
    text: "We have been working with Tycho Technologies since their inception and the relationship is strong every year.",
    initials: "AG",
    image: "/images/testimonialsImages/gemini.webp",
  },
  {
    name: "Suhas Sonawane",
    role: "Director Engg.",
    company: "Job Dost",
    text: "Tycho has been very professional and committed since the very beginning we started with them.",
    initials: "SS",
    image: "/images/testimonialsImages/jobdost.webp",
  },
  {
    name: "Joseph Jose",
    role: "Program Manager",
    company: "Every Point",
    text: "A team which is always ready and keen to take up any challenges thrown to them. Highly dedicated, committed and disciplined folks.",
    initials: "JJ",
    image: "/images/testimonialsImages/everypoint.webp",
  },
];

export const stats = [
  { value: 10, suffix: "+", label: "Successful\nYears", color: "#3b5bdb" },
  { value: 50, suffix: "+", label: "Team\nMembers", color: "#00b4d8" },
  { value: 300, suffix: "+", label: "Projects\nDelivered", color: "#74c614" },
  { value: 5, suffix: "+", label: "Star\nRatings", color: "#f79009" },
  { value: 10, suffix: "+", label: "Countries\nServed", color: "#00b4d8" },
  { value: 85, suffix: "%", label: "Repeat &\nReferral", color: "#748ffc" },
];
